import { c as _c } from "react/compiler-runtime";
// Вступление в партнёрскую программу: роль, имя, ссылки на каналы ->
// POST /partner/join. Роль потом переключается в шапке кабинета.
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Check, Megaphone, Video } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { api, type UgcPartnerRole } from "@/api";
import { partnerKey } from "@/components/partner/partner-ui";
import { Button } from "@/components/ui/button";
import { TextField } from "@/components/ui/text-field";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";
const ROLES: Array<{
  value: UgcPartnerRole;
  icon: typeof Video;
}> = [{
  value: "creator",
  icon: Video
}, {
  value: "arbitrage",
  icon: Megaphone
}];
export function PartnerJoin(t0) {
  const $ = _c(90);
  const {
    userId,
    defaultName
  } = t0;
  const {
    t
  } = useTranslation();
  const qc = useQueryClient();
  const [role, setRole] = useState("creator");
  let t1;
  if ($[0] !== defaultName) {
    t1 = defaultName.trim();
    $[0] = defaultName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [name, setName] = useState(t1);
  const [channels, setChannels] = useState("");
  const [touched, setTouched] = useState(false);
  let t2;
  if ($[2] !== channels || $[3] !== name || $[4] !== role) {
    t2 = () => api.ugc.partner.join({
      role,
      displayName: name.trim(),
      channels: channels.split("\n").map(_temp).filter(Boolean).slice(0, 20)
    });
    $[2] = channels;
    $[3] = name;
    $[4] = role;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== qc || $[7] !== t || $[8] !== userId) {
    t3 = profile => {
      qc.setQueryData(partnerKey(userId, "me"), profile);
      toast.success(t("partner.join.done"));
    };
    $[6] = qc;
    $[7] = t;
    $[8] = userId;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t) {
    t4 = e => toast.error(e instanceof Error ? e.message : t("common.error"));
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = {
      mutationFn: t2,
      onSuccess: t3,
      onError: t4
    };
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const join = useMutation(t5);
  let t6;
  if ($[16] !== name || $[17] !== t || $[18] !== touched) {
    t6 = touched && !name.trim() ? t("partner.join.nameRequired") : undefined;
    $[16] = name;
    $[17] = t;
    $[18] = touched;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const nameError = t6;
  let t7;
  if ($[20] !== t) {
    t7 = t("partner.join.title");
    $[20] = t;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t7) {
    t8 = <h1 className="text-[24px] leading-7 font-semibold tracking-[-0.4px] text-ds-ink md:text-[32px] md:leading-9">{t7}</h1>;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t) {
    t9 = t("partner.join.lead");
    $[24] = t;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t9) {
    t10 = <p className="text-[16px] leading-[21px] text-ds-secondary">{t9}</p>;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = ["benefit1", "benefit2", "benefit3"];
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t) {
    t12 = <ul className="flex flex-col gap-3">{(t11 as const).map(key => <li key={key} className="flex items-start gap-2.5 text-[14px] leading-[18px] font-medium text-ds-primary"><span className="mt-px grid size-5 shrink-0 place-items-center rounded-full bg-ds-accent text-white"><Check className="size-3" strokeWidth={3} aria-hidden="true" /></span>{t(`partner.join.${key}`)}</li>)}</ul>;
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t10 || $[32] !== t12 || $[33] !== t8) {
    t13 = <div className="flex min-w-0 flex-col gap-4">{t8}{t10}{t12}</div>;
    $[31] = t10;
    $[32] = t12;
    $[33] = t8;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== join || $[36] !== name) {
    t14 = e_0 => {
      e_0.preventDefault();
      setTouched(true);
      if (!name.trim() || join.isPending) {
        return;
      }
      join.mutate();
    };
    $[35] = join;
    $[36] = name;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t) {
    t15 = t("partner.join.role");
    $[38] = t;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t15) {
    t16 = <legend className="mb-2 text-[14px] leading-[18px] font-medium text-ds-label">{t15}</legend>;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== role || $[43] !== t) {
    t17 = ROLES.map(t18 => {
      const {
        value,
        icon: Icon
      } = t18;
      const active = role === value;
      return <label key={value} className={cn("flex cursor-pointer flex-col gap-1.5 rounded-[16px] border p-3 transition-colors has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-ds-focus", active ? "border-ds-primary bg-ds-quaternary" : "border-ds-line-2 hover:bg-ds-quaternary")}><input type="radio" name="partner-role" value={value} checked={active} onChange={() => setRole(value)} className="sr-only" data-testid={`partner-role-${value}`} /><span className="flex items-center gap-2 text-[16px] leading-5 font-semibold text-ds-ink"><Icon className="size-5 shrink-0" aria-hidden="true" />{t(`partner.role.${value}`)}</span><span className="text-[13px] leading-[17px] text-ds-secondary">{t(`partner.role.${value}Hint`)}</span></label>;
    });
    $[42] = role;
    $[43] = t;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== t17) {
    t18 = <div className="grid gap-2 sm:grid-cols-2">{t17}</div>;
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== t16 || $[48] !== t18) {
    t19 = <fieldset className="flex flex-col gap-2">{t16}{t18}</fieldset>;
    $[47] = t16;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t) {
    t20 = t("partner.join.name");
    $[50] = t;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== t) {
    t21 = t("partner.join.namePlaceholder");
    $[52] = t;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  let t23;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = e_1 => setName(e_1.target.value);
    t23 = () => setTouched(true);
    $[54] = t22;
    $[55] = t23;
  } else {
    t22 = $[54];
    t23 = $[55];
  }
  let t24;
  if ($[56] !== name || $[57] !== nameError || $[58] !== t20 || $[59] !== t21) {
    t24 = <TextField size="lg" label={t20} placeholder={t21} value={name} maxLength={120} onChange={t22} onBlur={t23} error={nameError} data-testid="partner-join-name" />;
    $[56] = name;
    $[57] = nameError;
    $[58] = t20;
    $[59] = t21;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] !== t) {
    t25 = t("partner.join.channels");
    $[61] = t;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== t25) {
    t26 = <label htmlFor="partner-channels" className="text-[14px] leading-[18px] font-medium text-ds-label">{t25}</label>;
    $[63] = t25;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = e_2 => setChannels(e_2.target.value);
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  let t28;
  if ($[66] !== channels) {
    t28 = <Textarea id="partner-channels" rows={3} value={channels} onChange={t27} placeholder={"https://t.me/mychannel\nhttps://vk.com/mygroup"} className="min-h-24 text-[14px] leading-[18px]" data-testid="partner-join-channels" />;
    $[66] = channels;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== t) {
    t29 = t("partner.join.channelsHint");
    $[68] = t;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  let t30;
  if ($[70] !== t29) {
    t30 = <p className="text-[12px] leading-4 text-ds-secondary">{t29}</p>;
    $[70] = t29;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  let t31;
  if ($[72] !== t26 || $[73] !== t28 || $[74] !== t30) {
    t31 = <div className="flex flex-col gap-1.5">{t26}{t28}{t30}</div>;
    $[72] = t26;
    $[73] = t28;
    $[74] = t30;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  const t32 = join.isPending;
  let t33;
  if ($[76] !== t) {
    t33 = t("partner.join.submit");
    $[76] = t;
    $[77] = t33;
  } else {
    t33 = $[77];
  }
  let t34;
  if ($[78] !== join.isPending || $[79] !== t33) {
    t34 = <Button type="submit" size="lg" disabled={t32} data-testid="partner-join-submit">{t33}</Button>;
    $[78] = join.isPending;
    $[79] = t33;
    $[80] = t34;
  } else {
    t34 = $[80];
  }
  let t35;
  if ($[81] !== t14 || $[82] !== t19 || $[83] !== t24 || $[84] !== t31 || $[85] !== t34) {
    t35 = <form className="flex min-w-0 flex-col gap-4 rounded-[20px] bg-white p-4 md:p-6" onSubmit={t14}>{t19}{t24}{t31}{t34}</form>;
    $[81] = t14;
    $[82] = t19;
    $[83] = t24;
    $[84] = t31;
    $[85] = t34;
    $[86] = t35;
  } else {
    t35 = $[86];
  }
  let t36;
  if ($[87] !== t13 || $[88] !== t35) {
    t36 = <section className="grid gap-4 rounded-[20px] bg-ds-quaternary px-3 py-4 md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] md:gap-8 md:p-8" data-testid="partner-join">{t13}{t35}</section>;
    $[87] = t13;
    $[88] = t35;
    $[89] = t36;
  } else {
    t36 = $[89];
  }
  return t36;
}
function _temp(line) {
  return line.trim();
}